/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';

import { useGlobalAppStorage } from '../../../providers/GlobalContextProvider';

export interface AppRedirectProps {
    currentLevelPath: string;
    redirectTo: string;
    keepQuery?: false;
}

export const AppRedirect: React.FC<AppRedirectProps> = ({
    currentLevelPath,
    redirectTo,
    keepQuery = true,
}) => {
    const appStorage = useGlobalAppStorage();
    const redirectFromStorage = appStorage?.getItem?.(currentLevelPath) ?? null;

    return (
        <Navigate
            replace
            to={`${redirectFromStorage ?? (redirectTo || './')}${keepQuery ? window.location.search : ''}`}
        />
    );
};
